/**
 * Helper function to create an initializer function for library-based
 * modules. Accepts the original module, and module extensions passed from
 * the consuming repo. All keys on the module extensions object are optional,
 * but at least an empty object must be passed.
 */
const initExtendedModule = (module, moduleExtensions) => ({
    state: { ...module.state, ...moduleExtensions.state },
    mutations: { ...module.mutations, ...moduleExtensions.mutations },
    actions: { ...module.actions, ...moduleExtensions.actions },
    getters: { ...module.getters, ...moduleExtensions.getters },
});

export { initExtendedModule };
